import type { FunctionComponent } from 'react';
import Select, { components, type OnChangeValue } from 'react-select';
import * as styles from './Dropdown.module.css';

export interface DropdownOption {
  value: string;
  label: string;
  isSelected: boolean;
}

export interface DropdownProps {
  values: DropdownOption[];
  onChange: (s: OnChangeValue<DropdownOption, false>) => void;
  placeholder?: string;
}

const CustomDropdownIndicator = (props: unknown) => (
  <components.DropdownIndicator {...props}>
    <i className={`${styles.dropdownIndicator} far fa-chevron-down`} />
  </components.DropdownIndicator>
);

const Dropdown: FunctionComponent<DropdownProps> = ({ values, onChange, placeholder }) => {
  const customStyles = {
    option: (provided: unknown) => ({
      ...provided,
      border: 'none',
      backgroundColor: 'white',
      color: 'black',
      padding: 6,
      height: '30px',
      ':hover': {
        backgroundColor: '#e8e8e8',
      },
      fontSize: '14px',
    }),
    control: (provided: unknown, state: unknown) => ({
      ...provided,
      width: state.selectProps.width,
      boxShadow: 'none',
      height: '48px',
      marginTop: 0,
      borderRadius: 6,
      border: 'solid 1px #d0d0d0',
      fontSize: '14px',
    }),
    menu: (provided: unknown) => ({
      ...provided,
      marginTop: 0,
    }),
  };

  const selectedOption = values.find((o) => o.isSelected);

  return (
    <div>
      <Select
        defaultValue={selectedOption}
        onChange={onChange}
        options={values}
        styles={customStyles}
        maxMenuHeight={152}
        placeholder={placeholder}
        components={{
          IndicatorSeparator: null,
          DropdownIndicator: CustomDropdownIndicator,
        }}
      />
    </div>
  );
};

export default Dropdown;
